"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};
var STATUS = exports.STATUS = {
  SENT: 0,
  ENTRUSTEDOWNER: 1,
  REQUESTED: 2,
  CONFIRMED: 3,
  CANCEL_SENT: 4,
  CANCELLED: 5,
  OWNER_CANCELLED: 6,
  REJECTED: 7,
  PAID: 8,
  PAYING: 9,
  REFUNDED: 10,
  ONSITE: 11,
  INVOICE: 12,
  EXPIRED: 13,
  SYSTEM_CANCELLED: 14,
  POSTPAY: 15
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/constants/reservation.js
// module id = 2089
// module chunks = 0